import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import { I18n } from "@aws-amplify/core";
import Box from "@material-ui/core/Box";
import { get } from "lodash";

import { fetchPost } from "../../../api/fetch";
import { setBreadcrumb } from "../../../actions/common";
import HspForm from "./HspForm";
import HspChart from "./HspChart";
import HspMap from "./HspMap";
import HspQuestionnaireResults from "./HspQuestionnaireResults";
import HspOnsiteDecision from "./HspOnsiteDecision";
import HspTopSymptoms from "./HspTopSymptoms";
import HspScreeningCoverage from "./HspScreeningCoverage";
import HspKioskMetrics from "./HspKioskMetrics";
import { computePeriod } from "../../../utils/date";

const styles = {
  container: {
    width: "100%",
    maxHeight: "calc(100vh - 100px)",
    overflow: "auto",
  },
  gridLine1: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(368px, 1fr))",
    gridAutoRows: "234px",
    gridGap: "24px",
    padding: "0px 24px 24px",
  },
  gridLine2: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(638px, 1fr))",
    gridAutoRows: "460px",
    gridGap: "24px",
    padding: "0px 24px 24px",
  },
  gridLine3: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridAutoRows: "max-content",
    gridGap: "24px",
    padding: "0px 24px 24px",
  },
};

const HspOriginalStatusDashboard = (props) => {
  const { classes, dispatch, language } = props;
  const [data, setData] = React.useState();
  const [filters, setFilters] = React.useState();

  React.useEffect(() => {
    dispatch(
      setBreadcrumb([
        {
          name: "dashboards",
          display: false,
        },
        {
          name: I18n.get("sidebar_hspOriginalStatusDashboard"),
        },
      ])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const search = async (filters) => {
    try {
      setData();

      let startDate = get(filters, ["startDate"]);
      let endDate = get(filters, ["endDate"]);
      if (get(filters, ["dateFilter"]) !== "custom") {
        [startDate, endDate] = computePeriod(get(filters, ["dateFilter"]));
      }

      let body = {
        period: {
          start: new Date(startDate).toISOString(),
          end: new Date(endDate).toISOString(),
        },
        header: {
          session_id: null,
          parent_org_id: null,
          org_id: null,
          site_id: get(filters, ["sites"]) ? get(filters, ["sites"]) : null,
          zone_id: null,
          zone_type: null,
          edge_id: null,
          camera_id: null,
          profile_id: null,
          profile_type: null,
          profile_tag_id: get(filters, ["tags"])
            ? get(filters, ["tags"])
            : null,
        },
      };
      setFilters(body);
      let res = await fetchPost("api/v1/es/kpi", body);
      setData(res);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Box className={classes.container}>
      <Box className="text-54 text-italic" style={{ margin: "8px 24px -16px" }}>
        {I18n.get("topbar_hspOriginalStatusDescription")}
      </Box>
      <HspForm search={search} language={language} />
      <Box className={classes.gridLine1}>
        <HspScreeningCoverage data={data} filters={filters} />
        <HspQuestionnaireResults data={data} filters={filters} />
        <HspOnsiteDecision data={data} filters={filters} />
        <HspTopSymptoms data={data} language={language} />
      </Box>
      <Box className={classes.gridLine2}>
        <HspMap data={get(data, ["activecases", "sites"])} />
        <HspChart data={get(data, ["activecases", "sites"])} />
      </Box>
      <Box className={classes.gridLine3}>
        <HspKioskMetrics data={get(data, ["additionalmetrics"])} />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(
  withStyles(styles)(HspOriginalStatusDashboard)
);
